import 'reflect-metadata';
import { Convertible, type TokensForInvestUnitWithDetails_And_Percentage, type TokensForInvestUnitWithDetails, asSmartDBEntity } from '../Commons';
import { deserealizeInvestUnitTypeWithADAPrices } from '../Commons/conversions';
import { InvestUnitEntity } from './Invest.Unit.Entity';

@asSmartDBEntity()
export class InvestUnitWithDetailsEntity extends InvestUnitEntity {
    protected static _apiRoute: string = 'investunits-with-details';
    protected static _className: string = 'InvestUnit With Details';
    protected static _mongoTableName: string = 'Invest Unit';

    // #region fields

    @Convertible({
        fromPlainObject: deserealizeInvestUnitTypeWithADAPrices,
    })
    investUnitWithADAPrices!: TokensForInvestUnitWithDetails_And_Percentage;

    // #endregion fields

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
    };

    // public static alwaysFieldsForCallbackOnAfterLoad(): Record<string, boolean> {
    //     return {
    //         ...super.alwaysFieldsForCallbackOnAfterLoad(),
    //         iudInvestUnit: true,
    //     };
    // }

    // #endregion db
}
